import { useSelector, useDispatch } from 'react-redux';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { Button, ButtonGroup, ConfirmDialog, Field, NumericInput, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { actions } from '../../../../../../Data/ReduxViewModels/WorksheetEditor';
import { isNil } from 'ramda';

let MeasurementsReadingsSectionBase: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
  prefixName,
}): JSX.Element => {
  const dispatch = useDispatch();
  const readings = useSelector(createWorksheetSelector!('Readings')) as any[];
  const additionalReadingExist = readings.some((x) => x.ReadingNumber === 4);
  const additionalReadingIsEmpty = readings.some((x) => x.ReadingNumber === 4 && isNil(x.BulkDensity));

  const dispatchObtainAdditionalReading = (value: boolean) => {
    dispatch(actions.setValue({ name: prefixName!('ObtainAdditionalReading'), value: value, sync: true }));
  };
  const handleAddAdditionalReading = () => dispatchObtainAdditionalReading(true);
  const handleRemoveAddAdditionalReading = () => dispatchObtainAdditionalReading(false);

  return (
    <>
      {readings.map((x, i) => {
        return (
          <ListFieldSection heading={`Reading ${x.ReadingNumber}`} key={'reading_' + i}>
            <Field input={<NumericInput />} name={`Readings[${i}].BulkDensity`} />
            <Field input={<TextOutput />} name={`Readings[${i}].CorrectedBulkDensity`} />
          </ListFieldSection>
        );
      })}
      <ButtonGroup>
        <Button visible={!additionalReadingExist} onClick={handleAddAdditionalReading}>
          Add Reading
        </Button>
        {additionalReadingIsEmpty ? (
          <Button error visible={additionalReadingExist} onClick={handleRemoveAddAdditionalReading}>
            Remove Reading
          </Button>
        ) : (
          <ConfirmDialog
            confirm
            confirmText="Removing a reading will delete all data present in that reading, this action cannot be undone. Continue?"
            confirmButtonText="Remove Reading"
            confirmTitle="Remove Reading"
          >
            <Button error visible={additionalReadingExist} onClick={handleRemoveAddAdditionalReading}>
              Remove Reading
            </Button>
          </ConfirmDialog>
        )}
      </ButtonGroup>
    </>
  );
};

const MeasurementsReadingsSection = withInjectedProps(MeasurementsReadingsSectionBase);
export { MeasurementsReadingsSection };
